import { RcFile } from "antd/es/upload";

import { axios, persistentQueryClient } from "utils";

import { GET_PLATFORM_CONTRACTS_ADMIN, ADMIN_SETTINGS_URL as endpoint } from "consts";

import { FeatureFlagsResponse, PlatformContract, UpdateFeatureFlagRequestBody } from "models";

export const getSettings = async (): Promise<{ [setting: string]: string }> => axios.get(`${endpoint}`);

export const updateSettings = async (data: { [setting: string]: string }, signal?: AbortSignal) => axios.put(`${endpoint}`, { data }, { signal });

// shapefile settings

export const getAllShapefileSettings = async (data: unknown) => axios.get(`${endpoint}/shapefiles`, { data });

export const getShapefileSettings = async (data: { id: string }) => axios.get(`${endpoint}/shapefiles/${data.id}`, { data });

export const updateShapefileSettings = async (data: { id: string }) => axios.put(`${endpoint}/shapefiles/${data.id}`, { data });

// emission factors

export const getEmissionFactors = async (data: unknown) => axios.get(`${endpoint}/emission-factors`, { data });

export const updateEmissionFactors = async (data: unknown) => axios.put(`${endpoint}/emission-factors`, { data });

// platform terms & conditions

export const getPlatformContracts = async (): Promise<PlatformContract[]> => axios.get(`${endpoint}/platform-contracts`);

const addPlatformContract = async (data: {
  countryCode: string;
  languageCode: string;
  description: string | null;
  file: string | ArrayBuffer | null;
}): Promise<{ filename: string }> => axios.post(`${endpoint}/platform-contracts`, { data });

export const parsePlatformContract = async (data: { countryCode: string; languageCode: string; description: string | null; file: RcFile }) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.readAsDataURL(data.file);

    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      addPlatformContract({
        file: reader.result,
        countryCode: data.countryCode,
        languageCode: data.languageCode,
        description: data.description,
      }).then((res) => {
        persistentQueryClient.invalidateQueries({ queryKey: [GET_PLATFORM_CONTRACTS_ADMIN] });
        resolve(res);
      });
    };
  });
};

export const updatePlatformContractDescription = async (data: { contractId: string; description: string | null }): Promise<PlatformContract> =>
  axios.put(`${endpoint}/platform-contracts/${data.contractId}/description`, { data: { description: data.description } });

export const getAllFeatureFlags = async (): Promise<FeatureFlagsResponse[]> => axios.get(`${endpoint}/feature-flags`);

export const updateFeatureFlag = async (data: UpdateFeatureFlagRequestBody): Promise<FeatureFlagsResponse> =>
  axios.put(`${endpoint}/feature-flags/${data.featureFlagId}`, {
    data: {
      enabledGlobally: data.enabledGlobally,
      ...(data.enabledCountryCodes !== undefined && { enabledCountryCodes: data.enabledCountryCodes }),
    },
  });
